<template>
  <v-form class="empresa-form">
    <v-row fluid>
      <v-col cols="12">
        <div v-if="id_empresa" class="continuar-aviso">
          <v-icon color="#0052A0" small left>mdi-information-outline</v-icon>
          Continuando um cadastro que você já havia começado.
        </div>
        <v-stepper v-model="e1" elevation="0" class="empresa-stepper">
          <v-stepper-header>
            <v-stepper-step
              :complete="stepComplete(1)"
              :rules="[() => !!validPessoais]"
              :color="stepStatus(1)"
              step="1"
              >Dados cadastrais</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              step="2"
              :complete="stepComplete(2)"
              :rules="[() => !!validEndereco]"
              :color="stepStatus(2)"
              >Endereço</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              :complete="stepComplete(3)"
              :rules="[() => !!validDocumento]"
              :color="stepStatus(3)"
              step="3"
              >Documentos
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="stepComplete(4)"
              :rules="[() => !!validPlanos]"
              :color="stepStatus(4)"
              step="4"
              >Escolha do plano
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              :complete="stepComplete(5)"
              :rules="[() => !!validTermos]"
              :color="stepStatus(5)"
              step="5"
              >Finalização
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <div class="form-section form-section--last">
                <div class="form-section__header">
                  <div class="form-section__icon-wrap">
                    <v-icon color="#0052A0" size="20">mdi-account-outline</v-icon>
                  </div>
                  <div>
                    <div class="form-section__title">Dados cadastrais</div>
                    <div class="form-section__sub">
                      Informe seus dados pessoais para cadastrar seu CPF como credor.
                    </div>
                  </div>
                </div>
                <div class="form-section__body">
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <v-text-field
                        outlined dense color="#0052A0"
                        v-model="etapa_um.cpf_cnpj"
                        label="CPF"
                        v-cpf:model="etapa_um.cpf_cnpj"
                        required
                        :rules="cpfRule"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        outlined dense color="#0052A0"
                        v-model="etapa_um.name"
                        label="Nome completo"
                        required
                        :rules="nameRule"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field
                        outlined dense color="#0052A0"
                        v-model="etapa_um.email"
                        label="E-mail "
                        required
                        :rules="emailRule"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        outlined dense color="#0052A0"
                        v-model="etapa_um.telefone"
                        label="Telefone"
                        v-phone:model="etapa_um.telefone"
                        required
                        :rules="telefoneRule"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        outlined dense color="#0052A0"
                        v-model="etapa_um.whats"
                        label="WhatsApp"
                        required
                        :rules="whatsRule"
                        v-phone:model="etapa_um.whats"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div class="form-actions">
                <v-btn color="#0052A0" rounded elevation="0" :loading="loading" @click="validate(1)" class="px-6">
                  <v-icon left color="#FFD400" small>mdi-arrow-right</v-icon>
                  <span style="color:#FFD400;font-weight:700;font-size:13px">Avançar</span>
                </v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="2">
              <div class="form-section form-section--last">
                <div class="form-section__header">
                  <div class="form-section__icon-wrap">
                    <v-icon color="#0052A0" size="20">mdi-map-marker-outline</v-icon>
                  </div>
                  <div>
                    <div class="form-section__title">Endereço</div>
                    <div class="form-section__sub">Informe seu endereço residencial ou comercial.</div>
                  </div>
                </div>
                <div class="form-section__body">
                  <v-row dense>
                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="etapa_dois.cep"
                        label="CEP"
                        required
                        :rules="cepRule"
                        maxsength="9"
                        v-mask="'#####-###'"
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-select
                        v-bind:items="ufs"
                        v-model="etapa_dois.uf"
                        outlined dense color="#0052A0"
                        label="UF"
                      >
                        <template slot="item" scope="data">
                          {{ data.item }}
                        </template>
                        <template slot="selection" scope="data">
                          {{ data.item }}
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-bind:items="municipios"
                        v-model="etapa_dois.municipio"
                        outlined dense color="#0052A0"
                        item-value="municipio"
                        item-text="municipio"
                        label="Município"
                      >
                        <template slot="item" scope="data">
                          {{ data.item.municipio }}
                        </template>
                        <template slot="selection" scope="data">
                          {{ data.item.municipio }}
                        </template>
                      </v-select>
                    </v-col>

                    <v-col cols="12" md="5">
                      <v-text-field
                        v-model="etapa_dois.endereco"
                        label="Endereço "
                        required
                        :rules="enderecoRule"
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-text-field
                        v-model="etapa_dois.numero"
                        label="Nº"
                        required
                        :rules="numeroRule"
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="etapa_dois.complemento"
                        label="Complemento"
                        required
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="etapa_dois.bairro"
                        label="Bairro"
                        required
                        :rules="bairroRule"
                        outlined dense color="#0052A0"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div class="form-actions">
                <v-btn text rounded color="grey darken-1" @click="e1 = 1">
                  <v-icon left small>mdi-arrow-left</v-icon>Voltar
                </v-btn>
                <v-btn color="#0052A0" rounded elevation="0" @click="validate(2)" class="px-6">
                  <v-icon left color="#FFD400" small>mdi-arrow-right</v-icon>
                  <span style="color:#FFD400;font-weight:700;font-size:13px">Avançar</span>
                </v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="3">
              <div v-if="e1 > 3" class="documentos-aviso">
                <v-icon color="#0052A0" small left>mdi-check-circle-outline</v-icon>
                Documentos já enviados anteriormente. Você só precisa reenviar se algo tiver sido reprovado.
              </div>

              <div class="form-section">
                <div class="form-section__header">
                  <div class="form-section__icon-wrap">
                    <v-icon color="#0052A0" size="20">mdi-card-account-details-outline</v-icon>
                  </div>
                  <div>
                    <div class="form-section__title">Documento de identificação</div>
                    <div class="form-section__sub">Envie seu RG ou sua CNH, frente e verso.</div>
                  </div>
                </div>
                <div class="form-section__body">
                  <div class="field-group-label">Documento de identificação</div>
                  <v-row dense>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        v-model="rg"
                        label="RG"
                        color="#0052A0"
                        @change="rgAction"
                        class="shrink mr-2 mt-0"
                        hide-details
                      ></v-checkbox>
                      <v-checkbox
                        v-model="cnh"
                        label="CNH"
                        color="#0052A0"
                        @change="cnhAction"
                        class="shrink mr-2 mt-0"
                        hide-details
                      ></v-checkbox>
                    </v-col>

                    <v-col cols="12" md="9">
                      <v-row dense>
                        <v-col cols="12" md="6" v-if="rg">
                          <v-file-input
                            v-model="etapa_tres.rg_frente"
                            label="RG Frente"
                            outlined dense color="#0052A0"
                            prepend-inner-icon="mdi-paperclip"
                            prepend-icon=""
                            :disabled="!rg"
                            accept="image/*, application/pdf"
                            :rules="rgFrenteRule"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12" md="6" v-if="rg">
                          <v-file-input
                            v-model="etapa_tres.rg_verso"
                            label="RG Verso"
                            outlined dense color="#0052A0"
                            prepend-inner-icon="mdi-paperclip"
                            prepend-icon=""
                            :disabled="!rg"
                            accept="image/*, application/pdf"
                            :rules="rgVersoRule"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12" md="6" v-if="cnh">
                          <v-file-input
                            v-model="etapa_tres.cnh_documento"
                            label="CNH"
                            outlined dense color="#0052A0"
                            prepend-inner-icon="mdi-paperclip"
                            prepend-icon=""
                            :disabled="!cnh"
                            accept="image/*, application/pdf"
                            :rules="cnhRule"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div class="form-section form-section--last">
                <div class="form-section__header">
                  <div class="form-section__icon-wrap">
                    <v-icon color="#0052A0" size="20">mdi-file-document-outline</v-icon>
                  </div>
                  <div>
                    <div class="form-section__title">Comprovante de endereço</div>
                    <div class="form-section__sub">Envie um comprovante atualizado (últimos 90 dias).</div>
                  </div>
                </div>
                <div class="form-section__body">
                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-file-input
                        v-model="etapa_tres.comprovante_endereco"
                        label="Comprovante de endereço atualizado"
                        outlined dense color="#0052A0"
                        prepend-inner-icon="mdi-paperclip"
                        prepend-icon=""
                        accept="image/*, application/pdf"
                        :rules="comprovanteRule"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div class="form-actions">
                <v-btn text rounded color="grey darken-1" @click="e1 = 2">
                  <v-icon left small>mdi-arrow-left</v-icon>Voltar
                </v-btn>
                <v-btn color="#0052A0" rounded elevation="0" :loading="loading" @click="validate(3)" class="px-6">
                  <v-icon left color="#FFD400" small>mdi-arrow-right</v-icon>
                  <span style="color:#FFD400;font-weight:700;font-size:13px">Avançar</span>
                </v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="4">
              <div class="form-section form-section--last">
                <div class="form-section__header">
                  <div class="form-section__icon-wrap">
                    <v-icon color="#0052A0" size="20">mdi-tag-outline</v-icon>
                  </div>
                  <div>
                    <div class="form-section__title">Escolha o seu plano</div>
                    <div class="form-section__sub">
                      Compare os serviços incluídos em cada plano e escolha o que melhor atende você. Você pode ver todos os detalhes antes de decidir.
                    </div>
                  </div>
                </div>
                <div class="form-section__body">
                  <v-row dense>
                    <v-col
                      cols="12"
                      sm="6"
                      lg="4"
                      v-for="item in listPlanos"
                      :key="item.id"
                    >
                      <div class="plano-card">
                        <div class="plano-card__header">
                          <div class="plano-card__nome">{{ item.nome }}</div>
                          <div class="plano-card__descricao">{{ item.descricao }}</div>
                        </div>

                        <div class="plano-card__body">
                          <v-chip
                            label
                            outlined
                            v-for="(serv, i) in item.services"
                            v-bind:key="serv.id"
                            v-show="i <= 10"
                            class="plano-card__chip"
                            color="#0052A0"
                          >
                            <strong>{{ serv.descricao }}</strong>
                            <small v-if="serv.qt_max > 0">&nbsp;({{ serv.qt_max }} ao mês)</small>
                            <small v-else>&nbsp;({{ converterDinherio(serv.valor_service) }} por utilização)</small>
                          </v-chip>

                          <div class="plano-card__detalhes" @click="servicesModal(item)">
                            Ver detalhes de todos os serviços
                          </div>
                        </div>

                        <div class="plano-card__preco">
                          <div class="plano-card__valor">{{ converterDinherio(item.total) }}</div>
                          <div class="plano-card__periodo-label">por mês</div>
                          <div
                            v-for="periodos in item.periodo"
                            :key="periodos.id"
                            class="plano-card__desconto"
                          >
                            {{ periodos.periodo }} com {{ periodos.desconto }}% de desconto
                          </div>
                        </div>

                        <div class="plano-card__acao">
                          <v-btn
                            block
                            color="#0052A0"
                            rounded
                            height="40"
                            elevation="0"
                            @click="escolher(item)"
                            class="plano-card__btn"
                          >
                            Escolher este plano
                          </v-btn>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div class="form-actions">
                <v-btn text rounded color="grey darken-1" @click="e1 = 3">
                  <v-icon left small>mdi-arrow-left</v-icon>Voltar
                </v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="5">
              <div class="form-section">
                <div class="form-section__header">
                  <div class="form-section__icon-wrap">
                    <v-icon color="#0052A0" size="20">mdi-clipboard-check-outline</v-icon>
                  </div>
                  <div>
                    <div class="form-section__title">Confira seu plano</div>
                    <div class="form-section__sub">Tem um cupom de desconto? Aplique antes de finalizar.</div>
                  </div>
                </div>
                <div class="form-section__body" v-if="etapa_cinco.plano">
                  <div class="resumo-plano">
                    <div class="resumo-plano__header">
                      <div class="resumo-plano__nome">{{ etapa_cinco.plano.nome }}</div>
                      <div class="resumo-plano__descricao">{{ etapa_cinco.plano.descricao }}</div>
                    </div>

                    <v-row dense class="pa-4">
                      <v-col cols="12" md="7">
                        <v-chip
                          label
                          outlined
                          v-for="(serv, i) in etapa_cinco.plano.services"
                          v-bind:key="serv.id"
                          v-show="i <= 10"
                          class="plano-card__chip"
                          color="#0052A0"
                        >
                          <strong>{{ serv.descricao }}</strong>
                          <small v-if="serv.qt_max > 0">&nbsp;({{ serv.qt_max }} ao mês)</small>
                          <small v-else>&nbsp;({{ converterDinherio(serv.valor_service) }} por utilização)</small>
                        </v-chip>

                        <div class="plano-card__detalhes" @click="servicesModal(etapa_cinco.plano)">
                          Ver detalhes de todos os serviços
                        </div>
                      </v-col>

                      <v-col cols="12" md="5" class="resumo-plano__preco-col">
                        <v-btn
                          outlined
                          rounded
                          elevation="0"
                          color="#0052A0"
                          @click="dialogInformarCupom = true"
                          class="px-4 mb-3"
                        >
                          <v-icon left small>mdi-tag-outline</v-icon>
                          <span style="font-size:13px">Inserir cupom de desconto</span>
                        </v-btn>

                        <div v-if="cupom_desconto.id != null">
                          <p class="resumo-plano__cupom-original">
                            <small style="text-decoration: line-through">
                              de: {{ converterDinherio(cupom_desconto.valor_original) }}
                            </small>
                            <v-chip class="ma-2" color="success" text-color="white" small>
                              -
                              {{
                                cupom_desconto.type == 1
                                  ? converterDinherio(cupom_desconto.valor)
                                  : cupom_desconto.valor + "%"
                              }}
                            </v-chip>
                          </p>
                          <p class="resumo-plano__valor-final">
                            <small>por:&nbsp;</small><b>{{ converterDinherio(cupom_desconto.valor_final) }}</b>
                          </p>
                        </div>
                        <div v-else class="resumo-plano__valor">
                          {{ converterDinherio(etapa_cinco.plano.total) }} <span class="resumo-plano__valor-sub">mensal</span>
                        </div>

                        <div
                          v-for="periodos in etapa_cinco.plano.periodo"
                          :key="periodos.id"
                          class="plano-card__desconto"
                        >
                          {{ periodos.periodo }} com {{ periodos.desconto }}% de desconto
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </div>

              <div class="form-section form-section--last">
                <div class="form-section__header">
                  <div class="form-section__icon-wrap">
                    <v-icon color="#0052A0" size="20">mdi-file-sign</v-icon>
                  </div>
                  <div>
                    <div class="form-section__title">Termos de uso e contrato</div>
                    <div class="form-section__sub">Leia com atenção e aceite para concluir seu cadastro.</div>
                  </div>
                </div>
                <div class="form-section__body">
                  <div class="termos-box">
                    <div v-html="text_termo" />
                  </div>

                  <v-lazy
                    v-model="isActive"
                    :options="{ threshold: 1 }"
                    min-height="60"
                    transition="fade-transition"
                  >
                    <v-checkbox
                      v-model="etapa_cinco.termos"
                      label="ACEITO OS TERMOS DE USO E CONTRATO"
                      color="#0052A0"
                      hide-details
                    ></v-checkbox>
                  </v-lazy>
                </div>
              </div>

              <div class="form-actions">
                <v-btn text rounded color="grey darken-1" @click="e1 = 4">
                  <v-icon left small>mdi-arrow-left</v-icon>Voltar
                </v-btn>
                <v-btn
                  color="#0052A0" rounded elevation="0"
                  :disabled="!etapa_cinco.termos"
                  @click="validate(5)"
                  class="px-6"
                >
                  <v-icon left color="#FFD400" small>mdi-check</v-icon>
                  <span style="color:#FFD400;font-weight:700;font-size:13px">Finalizar cadastro</span>
                </v-btn>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog v-model="dialogInformarCupom" width="600">
        <v-card>
          <div class="dialog-header">
            <div class="dialog-header__icon-wrap">
              <v-icon color="#0052A0">mdi-tag-outline</v-icon>
            </div>
            <div>
              <div class="dialog-header__title">Cupom de desconto</div>
              <div class="dialog-header__sub">Informe o código para aplicar ao seu plano</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogInformarCupom = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
          </div>

          <v-card-text class="pa-6">
            <v-row dense>
              <v-col cols="12" md="8">
                <v-text-field
                  outlined dense color="#0052A0"
                  label="Código do cupom"
                  v-model="srcCupom"
                  @keypress.enter="aplicarCupom"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn
                  outlined rounded elevation="0" color="#0052A0"
                  :loading="ldnValidar"
                  @click="validarCupom"
                  block
                >
                  <v-icon left small>mdi-check</v-icon>
                  <span style="font-size:13px">Validar</span>
                </v-btn>
              </v-col>

              <v-col v-if="cupom_desconto.id != null" cols="12">
                <v-divider class="mb-4"></v-divider>
                <p class="cupom-resumo-linha">
                  Valor original: <b>{{ converterDinherio(cupom_desconto.valor_original) }}</b>
                </p>
                <p class="cupom-resumo-linha">
                  Desconto:
                  <b>
                    {{
                      cupom_desconto.type == 1
                        ? converterDinherio(cupom_desconto.valor)
                        : cupom_desconto.valor + "%"
                    }}
                  </b>
                </p>
                <p class="cupom-resumo-linha">
                  Valor final: <b>{{ converterDinherio(cupom_desconto.valor_final) }}</b>
                </p>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions style="border-top:1px solid #f1f5f9;padding:12px 20px;">
            <v-spacer></v-spacer>
            <v-btn text rounded color="grey darken-1" @click="dialogInformarCupom = false" class="mr-2">
              <v-icon left small>mdi-close</v-icon>Cancelar
            </v-btn>
            <v-btn
              color="#0052A0" rounded elevation="0"
              :disabled="cupom_desconto.id == null"
              @click="aplicarCupom"
              class="px-6"
            >
              <v-icon left color="#FFD400" small>mdi-check</v-icon>
              <span style="color:#FFD400;font-weight:700;font-size:13px">Aplicar cupom</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <modal-services-component
        :dialog_log="modal"
        :registros="listServices"
        @close="modal = false"
      ></modal-services-component>
    </v-row>
  </v-form>
</template>

<script>
import { /* isCNPJ,*/ isCPF } from "vuetify-masks-br";
import ModalServicesComponent from "../../components/ModalServicesComponent";

import axios from "axios";
import { mapActions } from "vuex";
import helper from "../../mixins/helper";
export default {
  mounted() {
    this.listaMunicipios();
    this.planos();
    this.id_empresa = this.$route.params.empresa_id ?? null;
    if (this.id_empresa && this.$route.params.tipo_fj == "0") {
      this.continuarCadastro();
    }
  },
  mixins: [helper],
  components: { ModalServicesComponent },
  data: () => ({
    e1: 1,
    id_empresa: null,
    dialogInformarCupom: false,
    ldnValidar: false,
    rg: true,
    municipios: [],
    ufs: [
      "RO",
      "AC",
      "AM",
      "RR",
      "PA",
      "AP",
      "TO",
      "MA",
      "PI",
      "CE",
      "RN",
      "PB",
      "PE",
      "AL",
      "SE",
      "BA",
      "MG",
      "ES",
      "RJ",
      "SP",
      "PR",
      "SC",
      "RS",
      "MS",
      "MT",
      "GO",
      "DF",
    ].sort(),
    loading: false,

    contErro: false,
    srcCupom: null,

    contrato_s: true,
    ato_cons: false,
    insc_estadual: true,
    insc_municipal: false,
    buscarDadosReceitaLoading: false,
    cnh: false,
    isActive: false,
    modal: false,
    listPlanos: [],

    cupom_desconto: {
      id: null,
      cupom: null,
      valor: 0.0,
      valor_original: 0.0,
      valor_final: 0.0,
      type: 0,
    },
    listServices: [],
    text_termo: "",
    etapa_um: {
      name: null,
      email2: null,
      nameFantasy: null,
      cpf_cnpj: null,
      telefone: null,
      whats: null,
      user_juridica: false,
      inscricao_estadual: null,
      inscricao_municipal: null,
      etapa_um: 1,
    },
    etapa_dois: {
      cpf_cnpj: null,
      endereco: null,
      complemento: null,
      uf: null,
      numero: null,
      bairro: null,
      municipio: null,
      cep: "",
      cepConvertido: null,
      user_juridica: false,
      etapa_dois: 2,
    },
    etapa_tres: {
      cpf_cnpj: "",
      cnh: false,
      rg: true,
      user_juridica: false,
      etapa_tres: 3,
      comprovante_endereco: null,
      rg_frente: null,
      rg_verso: null,
      cnh_documento: null,

      cartao_cnpj: null,
      contrato_social: true,
      ato_constitutivo: false,

      doc_contrato_social: null,
      doc_ato_constitutivo: null,

      inscricao_estadual: true,
      inscricao_municipal: false,

      doc_inscricao_estadual: null,
      doc_inscricao_municipal: null,
    },
    etapa_quatro: {
      plano: null,
      etapa_quatro: 4,
    } /* etapa_cinco.cupomDesconto  */,
    etapa_cinco: {
      cupom_id: null,
      termos: false,
      cpf_cnpj: null,
      etapa_cinco: 5,
      plano: null,
    },
    validPessoais: true,
    validEndereco: true,
    validTermos: true,
    validPlanos: true,
    validDocumento: true,

    cpfRule: [
      (v) => !!v || "CPF é obrigatório",
      (v) => isCPF(v || "") || "CPF não é válido.",
    ],
    nameRule: [
      (v) => !!v || "Nome é obrigatório",
      (v) => (v || "").length >= 5 || "Mínimo de 5 caracteres",
    ],

    email2Rule: [
      (v) => !!v || "E-mail é obrigatório",
      (v) => /.+@.+\..+/.test(v) || "Insira um E-mail válido",
    ],
    telefoneRule: [
      (v) => !!v || "Telefone é obrigatório",
      (v) => (v || "").length >= 14 || "Preencha todo campo",
    ],
    whatsRule: [
      (v) => !!v || "WhatsApp é obrigatório",
      (v) => (v || "").length >= 14 || "Preencha todo campo",
    ],
    cepRule: [(v) => !!v || "CEP é obrigatório"],
    municipioRule: [(v) => !!v || "Municipio é obrigatório"],
    ufRule: [(v) => !!v || "UF é obrigatório"],
    enderecoRule: [(v) => !!v || "Endereço é obrigatório"],
    complementoRule: [(v) => !!v || "Complemento é obrigatório"],
    numeroRule: [(v) => !!v || "Nº é obrigatório"],
    bairroRule: [(v) => !!v || "Bairro é obrigatório"],

    comprovanteRule: [
      (value) => !value || value.size < 2000000 || "Tamanho máximo é 2MB!",
      (v) => !!v || "Comprovante é obrigatório",
    ],
    rgFrenteRule: [
      (value) => !value || value.size < 2000000 || "Tamanho máximo é 2MB!",
    ],
    rgVersoRule: [
      (value) => !value || value.size < 2000000 || "Tamanho máximo é 2MB!",
    ],
    cnhRule: [
      (value) => !value || value.size < 2000000 || "Tamanho máximo é 2MB!",
    ],
  }),

  methods: {
    ...mapActions("auth", ["registerEmpresaFile", "ActionEmpresaComplete"]),

    Cadastar() {
      this.$router.push({ name: "Cadastro de Empresas" });
    },

    continuarCadastro() {
      this.$swal({
        toast: true,
        position: "bottom",
        showConfirmButton: false,
        background: "#4BB543",
        timer: 3000,
        icon: "success",
        title: '<span style="color:#FFF">Continuando cadastro..</span>',
      });
      this.loading = true;
      this.$http
        .get("continuarCadastroEmpresa/" + this.id_empresa)
        .then((response) => {
          console.log(response.data);
          this.e1 = response.data.etapa;
          this.etapa_um.name = response.data.name;

          this.etapa_um.email2 = response.data.email2;
          this.etapa_um.nameFantasy = response.data.nameFantasy;
          this.etapa_um.cpf_cnpj = response.data.cpf_cnpj;
          this.etapa_um.telefone = response.data.telefone;
          this.etapa_um.whats = response.data.whats;
          this.etapa_um.user_juridica = response.data.user_juridica;

          this.etapa_dois.cpf_cnpj = response.data.cpf_cnpj;

          this.etapa_dois.endereco = response.data.endereco;
          this.etapa_dois.complemento = response.data.complemento;
          this.etapa_dois.uf = response.data.uf;
          this.etapa_dois.numero = response.data.numero;
          this.etapa_dois.bairro = response.data.bairro;
          this.etapa_dois.municipio = response.data.municipio;
          this.etapa_dois.cep = response.data.cep;
          this.etapa_dois.user_juridica = false;
          this.loading = false;
        })
        .catch((erro) => {
          console.log(erro);
          this.loading = false;
          this.notificacao("Por favor", "Não foi possível carregar o cadastro em andamento.");
        });
      //this.e1 = 2;
    },
    stepComplete(step) {
      return this.e1 > step;
    },
    stepStatus(n) {
      return this.e1 > n ? "#22c55e" : "#0052A0";
    },

    async listaMunicipios() {
      await this.$http.get("listamunicipios").then((response) => {
        this.municipios = response.body;
      });
    },

    escolher(item) {
      this.etapa_quatro.plano = item;
      this.etapa_cinco.plano = item;
      this.validate(4);

      this.termo();
    },
    async validate(n) {
      this.loading = true;
      if (n == 1) {
        if (
          !this.etapa_um.name ||
          !this.etapa_um.cpf_cnpj ||
          !this.etapa_um.whats ||
          !this.etapa_um.email2 ||
          !this.etapa_um.telefone
        ) {
          this.validPessoais = false;
          this.loading = false;
        } else {
          this.etapa_um.cpf_cnpj = this.etapa_um.cpf_cnpj.replace(
            /([^\d])+/gim,
            ""
          );
          this.etapa_um.telefone = this.etapa_um.telefone.replace(
            /([^\d])+/gim,
            ""
          );

          this.$http
            .get("empresaExiste/" + this.etapa_um.cpf_cnpj)
            .then(async (response) => {
              const value = parseInt(response.data.validacao);
              this.loading = false;
              if (value !== 0) {
                this.$swal({
                  toast: true,
                  position: "bottom",
                  showConfirmButton: false,
                  background: "#ff0000",
                  timer: 3000,
                  icon: "error",
                  title: '<span style="color:#FFF">Desculpe</span>',
                  html: '<span style="color:#FFF">CPF/CNPJ já está cadastrado</span>',
                });
                this.validPessoais = false;
                n = 1;
                return 0;
              } else {
                this.etapa_um.whats = this.etapa_um.whats.replace(
                  /([^\d])+/gim,
                  ""
                );

                this.etapa_um.whats = this.etapa_um.whats.replace(
                  /([^\d])+/gim,
                  ""
                );
                this.validPessoais = true;
                try {
                  const data = await this.ActionEmpresaComplete(this.etapa_um);
                  this.etapa_dois.cpf_cnpj = this.etapa_um.cpf_cnpj;
                  this.e1 = n + 1;
                  console.log(data);
                } catch (erro) {
                  console.log(erro);
                  this.$swal({
                    toast: true,
                    position: "bottom",
                    showConfirmButton: false,
                    background: "#ff0000",
                    timer: 3000,
                    icon: "error",
                    title: '<span style="color:#FFF">Desculpe</span>',
                    html: '<span style="color:#FFF">CPF/CNPJ já existe</span>',
                  });
                }
              }
            })
            .catch((erro) => {
              console.log(erro);
              this.loading = false;
              this.notificacao("Por favor", "Não foi possível validar o CPF. Tente novamente.");
            });
        }
      }
      if (n == 2) {
        if (
          !this.etapa_dois.cep ||
          !this.etapa_dois.municipio ||
          !this.etapa_dois.uf ||
          !this.etapa_dois.endereco ||
          !this.etapa_dois.numero ||
          !this.etapa_dois.bairro
        ) {
          this.validEndereco = false;
          this.loading = false;
        } else {
          this.etapa_dois.cepConvertido = this.etapa_dois.cep.replace(
            /([^\d])+/gim,
            ""
          );
          this.etapa_dois.cpf_cnpj = this.etapa_dois.cpf_cnpj.replace(
            /([^\d])+/gim,
            ""
          );

          this.validEndereco = true;
          try {
            console.log(this.etapa_dois);
            const data = await this.ActionEmpresaComplete(this.etapa_dois);
            this.loading = false;
            data;
            this.etapa_tres.cpf_cnpj = this.etapa_dois.cpf_cnpj;
            this.e1 = n + 1;
          } catch (erro) {
            this.loading = false;
            this.notificacao("Por favor", "Não foi possível salvar o endereço. Tente novamente.");
          }
        }
      }
      if (n == 3) {
        if (this.etapa_tres.comprovante_endereco == null && n < 3) {
          this.validDocumento = false;
          this.notificacao("Por favor", "Preencha todos os campos");
          this.loading = false;
        } else {
          this.etapa_tres.cpf_cnpj = this.etapa_dois.cpf_cnpj.replace(
            /([^\d])+/gim,
            ""
          );
          let formData = new FormData();
          formData.append("etapa_tres", this.etapa_tres.etapa_tres);
          formData.append("cpf_cnpj", this.etapa_tres.cpf_cnpj);
          formData.append("user_juridica", this.etapa_tres.user_juridica);
          formData.append(
            "comprovante_endereco",
            this.etapa_tres.comprovante_endereco
          );
          formData.append("cartao_cnpj", this.etapa_tres.cartao_cnpj);

          formData.append("cnh", this.etapa_tres.cnh);
          formData.append("rg", this.etapa_tres.rg);
          formData.append("rg_frente", this.etapa_tres.rg_frente);
          formData.append("rg_verso", this.etapa_tres.rg_verso);
          formData.append("cnh_documento", this.etapa_tres.cnh_documento);

          formData.append("contrato_social", this.etapa_tres.contrato_social);
          formData.append("ato_constitutivo", this.etapa_tres.ato_constitutivo);
          formData.append(
            "doc_contrato_social",
            this.etapa_tres.doc_contrato_social
          );
          formData.append(
            "doc_ato_constitutivo",
            this.etapa_tres.doc_ato_constitutivo
          );

          formData.append(
            "inscricao_estadual",
            this.etapa_tres.inscricao_estadual
          );
          formData.append(
            "inscricao_municipal",
            this.etapa_tres.inscricao_municipal
          );
          formData.append(
            "doc_inscricao_estadual",
            this.etapa_tres.doc_inscricao_estadual
          );
          formData.append(
            "doc_inscricao_municipal",
            this.etapa_tres.doc_inscricao_municipal
          );

          if (this.etapa_tres.rg) {
            if (
              this.etapa_tres.rg_frente == null ||
              this.etapa_tres.rg_verso == null
            ) {
              this.contErro = true;
              console.log("this.etapa_tres.rg");
            }
          }
          if (this.etapa_tres.cnh) {
            if (this.etapa_tres.cnh_documento == null) {
              this.contErro = true;
              console.log("this.etapa_tres.cnh");
            }
          }
          if (this.etapa_tres.comprovante_endereco) {
            if (this.etapa_tres.comprovante_endereco == null) {
              this.contErro = true;
              console.log("this.etapa_tres.comprovante_endereco");
            }
          }

          if (this.contErro) {
            this.contErro = false;
            this.validDocumento = false;
            this.loading = false;
            this.notificacao("Por favor", "Preencha todos os campos");
          } else if (!this.contErro) {
            this.validDocumento = true;

            this.sendArquivos(formData);
          } else {
            this.e1 = 4;
            this.loading = false;
          }
        }
      }
      if (n == 4) {
        if (this.etapa_quatro.plano != null) {
          this.validPlanos = true;
          this.e1 = n + 1;
          this.loading = false;
        } else {
          this.validPlanos = false;
          this.loading = false;
        }
      }
      if (n == 5) {
        if (this.etapa_cinco.termos) {
          this.etapa_cinco.cpf_cnpj = this.etapa_um.cpf_cnpj;
          this.$http.post("registerEmpresa", this.etapa_cinco).then(
            (response) => {
              // get body data
              console.log(response);
              this.loading = false;
              this.e1 = n + 1;
              this.$router.push({
                name: "Cadastro Enviado",
                query: { email: this.etapa_um.email2 || null },
              });
            },
            (response) => {
              console.log(response);
              this.validTermos = false;
              this.loading = false;
            }
          );
        } else {
          this.validTermos = false;
          this.loading = false;
        }
      }
    },
    async sendArquivos(formdata) {
      if (formdata != null) {
        try {
          const data = await this.registerEmpresaFile(formdata);
          if (data.data.erro) {
            this.notificacao("Erro", data.data.message);
            this.validDocumento = false;
            this.loading = false;
          } else {
            this.validDocumento = true;
            this.etapa_quatro.cpf_cnpj = this.etapa_tres.cpf_cnpj;
            this.e1 = 4;
            this.loading = false;
          }
        } catch (erro) {
          this.loading = false;
          erro;
        }
      }
    },
    aplicarCupom() {
      this.etapa_cinco.cupom = this.cupom_desconto;
      this.dialogInformarCupom = false;
    },
    validarCupom() {
      //carrega as informações para verificar se é válido

      this.ldnValidar = true;
      this.$http
        .post("prevalidacaocupom", {
          cupom: this.srcCupom,
          id_plano: this.etapa_quatro.id_plano,
        })
        .then(
          (response) => {
            console.log(response);
            this.cupom_desconto.id = response.body[0].id;
            this.cupom_desconto.cupom = response.body[0].cupom;
            this.cupom_desconto.valor = response.body[0].valor;
            this.cupom_desconto.type = response.body[0].type;
            this.cupom_desconto.valor_original = this.etapa_cinco.plano.total;
            this.cupom_desconto.valor_final =
              response.body[0].type == 1
                ? parseFloat(this.etapa_cinco.plano.total) -
                  parseFloat(response.body[0].valor)
                : parseFloat(this.etapa_cinco.plano.total) -
                  ( (parseFloat(response.body[0].valor) /100)* this.etapa_cinco.plano.total);

            console.log(this.cupom_desconto);
            this.ldnValidar = false;

            this.$swal({
              toast: false,
              showConfirmButton: true,
              icon: "success",
              title: "Cupom de desconto válido para aplicação",
            });
          },
          (response) => {
            console.log(response);
            this.ldnValidar = false;
            this.$swal({
              toast: false,
              showConfirmButton: true,
              icon: "error",
              title: "Não foi possível utilizar o cupom",
              text: "Cupom não existe ou expirado",
            });
          }
        );
    },
    planos() {
      this.loading = true;
      this.$http.get("Planos/1").then(
        (response) => {
          // get body data
          this.loading = false;
          this.listPlanos = response.data;
        },
        (response) => {
          console.log(response);
          this.loading = false;
          // error callback
        }
      );
    },
    servicesModal(registros) {
      this.modal = true;
      this.listServices = registros;
    },
    termo() {
      this.loading = true;
      this.$http.get("termo/showVigencia").then(
        (response) => {
          // get body data
          this.loading = false;
          this.text_termo = response.data.texto;
        },
        (response) => {
          console.log(response);
          this.loading = false;
          // error callback
        }
      );
    },

    rgAction(newValue) {
      this.etapa_tres.rg = newValue;
      this.etapa_tres.cnh = !newValue;
      this.cnh = !newValue;
      this.etapa_tres.cnh_documento = null;
    },
    cnhAction(newValue) {
      this.etapa_tres.cnh = newValue;
      this.etapa_tres.rg = !newValue;
      this.rg = !newValue;
      this.etapa_tres.rg_verso = null;
      this.etapa_tres.rg_frente = null;
    },

    contratoAction(newValue) {
      this.etapa_tres.contrato_social = newValue;
      this.etapa_tres.ato_constitutivo = !newValue;
      this.ato_cons = !newValue;
      this.etapa_tres.doc_ato_constitutivo = null;
    },
    atoConsAction(newValue) {
      this.etapa_tres.ato_constitutivo = newValue;
      this.etapa_tres.contrato_social = !newValue;
      this.contrato_s = !newValue;
      this.etapa_tres.doc_contrato_social = null;
    },
    estadualAction() {
      if (this.insc_estadual) {
        this.informar_depois_municipal = false;
        this.insc_municipal = false;
      }
    },
    municipalAction() {
      if (this.insc_municipal) {
        //  this.etapa_tres.inscricao_municipal = null;
        // this.etapa_tres.inscricao_estadual = null;

        this.informar_depois_municipal = false;
        this.insc_estadual = false;
      }
    },
    informarDepoisAction(newValue) {
      if (this.informar_depois_municipal) {
        this.insc_municipal = false;
        this.insc_estadual = false;
        this.etapa_tres.doc_inscricao_estadual = null;
        this.etapa_tres.inscricao_municipal = null;
        this.etapa_tres.inscricao_municipal = !newValue;
        this.etapa_tres.inscricao_estadual = !newValue;
      } else {
        this.etapa_tres.inscricao_estadual = true;
      }
    },

    notificacao(title, msg, icon = "error") {
      this.$swal({
        toast: true,
        position: "center-end",
        showConfirmButton: false,
        timer: 3000,
        icon: icon,
        title: title,
        text: msg,
      });
    },
  },

  watch: {
    "etapa_dois.uf": async function (ufchange) {
      await this.$http
        .get("listamunicipios?uf=" + ufchange)
        .then((response) => {
          console.log(response);
          this.municipios = [];
          this.municipios = response.body;
        });
    },

    "etapa_dois.cep": function (newValue) {
      var vm = this.etapa_dois;
      var values = this;

      var local = newValue.replace(/([^\d])+/gim, "");
      if (local.length == 8) {
        axios
          .get("https://viacep.com.br/ws/" + local + "/json/")
          .then(function (res) {
            if (!res.data.erro) {
              ///lert(res.data.localidade)
              vm.municipio = res.data.localidade;
              vm.uf = res.data.uf;
              vm.bairro = res.data.bairro;
              vm.endereco = res.data.logradouro;

              //  alert(vm.municipio);
            } else {
              values.$swal({
                toast: true,
                position: "center-end",
                showConfirmButton: false,
                background: "#ff0000",
                timer: 3000,
                icon: "error",
                title: '<span style="color:#FFF">Desculpe</span>',
                html: '<span style="color:#FFF">CEP não encontrado</span>',
              });
            }
          })
          .catch(function (err) {
            err;
          });
      }
    },
  },
};
</script>
<style scoped>
.empresa-stepper {
  box-shadow: none !important;
}

.empresa-stepper >>> .v-stepper__header {
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  box-shadow: none;
}
.empresa-stepper >>> .v-stepper__step {
  padding: 20px 14px;
  flex-shrink: 0;
}
.empresa-stepper >>> .v-stepper__label {
  font-size: 0.82rem !important;
  white-space: nowrap;
}
.empresa-stepper >>> .v-divider {
  min-width: 24px;
}

@media (max-width: 1100px) {
  .empresa-stepper >>> .v-stepper__step {
    padding: 16px 10px;
  }
  .empresa-stepper >>> .v-stepper__label {
    font-size: 0.76rem !important;
  }
}

@media (max-width: 700px) {
  .empresa-stepper >>> .v-stepper__label {
    display: none;
  }
  .empresa-stepper >>> .v-stepper__step {
    padding: 12px 8px;
  }
  /* o card em volta já tem padding; aqui ele só espremia os campos no celular */
  .empresa-stepper >>> .v-stepper__content {
    padding: 16px 0 12px;
  }
}

.continuar-aviso {
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: #0052A0;
  background: #e8f0fe;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 16px;
}

.documentos-aviso {
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: #0052A0;
  background: #e8f0fe;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 20px;
}

/* ─── Seções do form ────────────────────────────────── */
.form-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.form-section--last {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}
.form-section__header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 0 0 18px 0;
}
.form-section__icon-wrap {
  width: 34px; height: 34px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}
.form-section__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.92rem;
  font-weight: 700;
  color: #1e293b;
}
.form-section__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #94a3b8;
  margin-top: 1px;
}
.form-section__body {
  padding: 0;
}

/* ─── Labels de grupo ───────────────────────────────── */
.field-group-label {
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #94a3b8;
  margin-bottom: 10px;
}

/* ─── Ações do formulário ───────────────────────────── */
.form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 24px 0 8px;
}

/* ─── Cards de plano (step 4) ───────────────────────── */
.plano-card {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.plano-card__header {
  background: #0052A0;
  padding: 16px 20px;
}
.plano-card__nome {
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: #fff;
}
.plano-card__descricao {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: rgba(255,255,255,.85);
  margin-top: 2px;
}
.plano-card__body {
  padding: 16px 20px;
  flex: 1;
}
.plano-card__chip {
  display: flex !important;
  width: 100%;
  height: auto !important;
  min-height: 32px;
  margin: 0 0 8px 0 !important;
  padding: 6px 12px !important;
  font-family: 'Inter', sans-serif;
  white-space: normal;
}
.plano-card__chip >>> .v-chip__content {
  display: block;
  height: auto;
  white-space: normal;
  line-height: 1.4;
  word-break: break-word;
}
.plano-card__detalhes {
  font-family: 'Inter', sans-serif;
  font-size: 0.8rem;
  font-weight: 600;
  color: #0052A0;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 8px;
}
.plano-card__preco {
  padding: 16px 20px;
  border-top: 1px solid #f1f5f9;
  text-align: center;
}
.plano-card__valor {
  font-family: 'Inter', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e293b;
}
.plano-card__periodo-label {
  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  color: #94a3b8;
}
.plano-card__desconto {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #F27C00;
  font-weight: 600;
}
.plano-card__acao {
  padding: 0 20px 20px;
  flex: 0 0 auto;
}
.plano-card__btn {
  color: #FFD400 !important;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: .3px;
  text-transform: none;
}

/* ─── Resumo do plano (step 5) ──────────────────────── */
.resumo-plano {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
}
.resumo-plano__header {
  background: #0052A0;
  padding: 16px 20px;
}
.resumo-plano__nome {
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: #fff;
}
.resumo-plano__descricao {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: rgba(255,255,255,.85);
  margin-top: 2px;
}
.resumo-plano__preco-col {
  text-align: center;
  border-left: 1px solid #f1f5f9;
}
.resumo-plano__valor {
  font-family: 'Inter', sans-serif;
  font-size: 1.4rem;
  font-weight: 700;
  color: #1e293b;
}
.resumo-plano__valor-sub {
  font-size: 0.8rem;
  font-weight: 400;
  color: #94a3b8;
}
.resumo-plano__cupom-original,
.resumo-plano__valor-final {
  font-family: 'Inter', sans-serif;
  color: #1e293b;
}

/* ─── Termos (step 5) ───────────────────────────────── */
.termos-box {
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
  background: #f8fafc;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: #1e293b;
}

/* ─── Dialogs ────────────────────────────────────────── */
.dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
}
.dialog-header__icon-wrap {
  width: 36px; height: 36px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.dialog-header__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
}
.dialog-header__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #94a3b8;
  margin-top: 2px;
}
.cupom-resumo-linha {
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: #1e293b;
  margin-bottom: 6px;
}

/* ─── Inputs ─────────────────────────────────────────── */
.empresa-form >>> .v-input__slot {
  background-color: #fff !important;
  box-shadow: none !important;
}
.empresa-form >>> .v-label {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.85rem !important;
}
.empresa-form >>> input,
.empresa-form >>> .v-select__selections {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.88rem !important;
  color: #1e293b !important;
}
</style>
